import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { DashboardInstallationColumn, KanbanBoardStore } from '@store';
import { GTMService } from '@services';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ViConfirmDirective } from '@vi-iot/ui';
import { CommonStandaloneModule } from '../../../../shared/common-standalone.module';
import { ChangeColumnSortOrderModalComponent } from '../../modals/change-column-sort-order-modal/change-column-sort-order-modal.component';

@Component({
  selector: 'app-kanban-column-menu',
  standalone: true,
  imports: [
    CommonStandaloneModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    ViConfirmDirective,
  ],
  templateUrl: './kanban-column-menu.component.html',
  styleUrls: ['./kanban-column-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KanbanColumnMenuComponent {
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  @Input() column: DashboardInstallationColumn;

  constructor(private kanbanBoardStore: KanbanBoardStore, private gtmService: GTMService) {}

  showEditInput(event: MouseEvent): void {
    event.stopImmediatePropagation();
    this.column.inputShowed = true;
    this.trigger.closeMenu();
  }
  openSortOrderModal(): void {
    this.kanbanBoardStore.openColumnDialog(ChangeColumnSortOrderModalComponent, this.column);
  }

  deleteColumn(): void {
    this.kanbanBoardStore.deleteColumn(this.column.id, this.column.version);
    this.gtmService.track(
      'onConfirm',
      'Dashboard delete column send request',
      'Delete dashboard column'
    );
  }
}
